import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d89f3a6e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d89f3a6e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89f3a6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d89f3a6e')) {
      api.createRecord('d89f3a6e', component.options)
    } else {
      api.reload('d89f3a6e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d89f3a6e&scoped=true&", function () {
      api.rerender('d89f3a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/caseHandle/proofExam/index.vue"
export default component.exports